import { useContext } from "react";
import ReportShowAllCheckbox from "components/ReportShowAllCheckbox";
import { TrendReportContext } from "contexts/TrendReportContext/TrendReportContext";

const DowntimeFailureTypeByMachineCenterCheckbox = () => {
    const {
        showAllMachineCenters,
        handleShowAllMachineCentersChange,
        selectedPreviousMachineCenter,
        selectedMachineCenter,
        handleSelectedPreviousMachineCenterChange,
        handleSetSelectedMachineCenter,
    } = useContext(TrendReportContext);

    return (
        <ReportShowAllCheckbox
            checked={showAllMachineCenters}
            onChange={(_, checked) => {
                handleShowAllMachineCentersChange(checked);
                if (checked) {
                    handleSelectedPreviousMachineCenterChange(selectedMachineCenter);
                    handleSetSelectedMachineCenter(undefined);
                } else {
                    handleSetSelectedMachineCenter(selectedPreviousMachineCenter);
                }
            }}
        />
    );
};

export default DowntimeFailureTypeByMachineCenterCheckbox;
